import extractDomain from 'extract-domain';
import Cookies from 'js-cookie';
import { COOKIES_KEYS } from '../../common/consts';
import { useNavigate } from 'react-router-dom';
import routes from '../../common/routes';

const useSessionManager = () => {
  const navigate = useNavigate();

  const domain = window.location.host.includes('localhost')
    ? 'localhost'
    : `.${extractDomain(window.location.host)}`;

  const clearToken = () => {
    Cookies.remove(COOKIES_KEYS.TOKEN);
    Cookies.remove(COOKIES_KEYS.TOKEN, { path: '/', domain });
  };

  const clearSession = async (redirectToLogin = true) => {
    clearToken();
    if (redirectToLogin) {
      return navigate(routes.login.path);
    }
  };

  return [clearSession];
};

export default useSessionManager;
